import { forwardRef } from "react";
import {
  Checkbox,
  type ICheckboxProps,
} from "@components/inputs/Checkbox/Checkbox";

const checkedSvgIcon =
  '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">\n' +
  '    <path d="M10 3L4.5 8.5L2 6" stroke="#D2F4DB" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>\n' +
  "</svg>";

export const TaxCollectorTypeCheckbox = forwardRef<
  HTMLInputElement,
  ICheckboxProps
>((props, ref) => (
  <Checkbox checkedSvgIcon={checkedSvgIcon} {...props} ref={ref} />
));
